import { ObjectMapper } from "json-object-mapper";
import { IModel } from "../IModel";
import { Model } from "../model";
import { FileModel } from "../file.model";

export class HiringConfigModel
  extends Model
  implements IModel<HiringConfigModel> {
  // smsCongratsMessage: string = "";
  // smsFinishedMessage: string = "";
  offerLetterMessage: string = "";
  offerLetterEmail: string = "";
  wppCoverImage: string = "";
  wppCoverImageFile: FileModel = new FileModel();
  wppCongratsMessage: string = "";
  wppFinishedMessage: string = "";
  wppInvalidDocsMessage: string = "";
  completionDeadline: number = 0;
  benefitsPDFUrl: string = "";
  benefitsPDF: FileModel = new FileModel();
  instructionsPdfUrl: string = "";
  instructionsPDF: FileModel = new FileModel();
  instructionsMp4Url: string = "";
  instructionsMP4: FileModel = new FileModel();
  setAdmissionForm: string = "";
  setApplicantForm: string = "";
  bankNumbers: string[] = [];
  sesmtAlertEmail: string = "";
  dpAlertEmail: string = "";
  finishedAlertEmail: string = "";
  companyGroupId: string = "";
  organizationId: string = "";
  hasOfferLetterStage: boolean = false;
  createRegistration: boolean = false;
  hasAdmissionExams: boolean = false;
  asoExamMessage: string = "";
  hasPreliminaryCourseStage: boolean = false;
  preliminaryCourseDocumentTypeId: string = "";
  hasPostAdmissionDocsStage: boolean = false;
  sendAsoAutomatically: boolean = false;
  usesOCR: boolean = false;
  notifyCandidates: boolean = true;

  static create(input: any): HiringConfigModel {
    return ObjectMapper.deserialize<HiringConfigModel>(
      HiringConfigModel,
      input
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
